module.exports = __webpack_public_path__ + "static/img/chengcai2.3f3bfa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chengcai2.png
// module id = gCjQ
// module chunks = 52